/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManagerResponse
 */
export interface ManagerResponse {
    /**
     * 
     * @type {string}
     * @memberof ManagerResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerResponse
     */
    fullname: string;
}

/**
 * Check if a given object implements the ManagerResponse interface.
 */
export function instanceOfManagerResponse(value: object): value is ManagerResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    return true;
}

export function ManagerResponseFromJSON(json: any): ManagerResponse {
    return ManagerResponseFromJSONTyped(json, false);
}

export function ManagerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManagerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullname': json['fullname'],
    };
}

export function ManagerResponseToJSON(value?: ManagerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fullname': value['fullname'],
    };
}

